<script setup>
import {ref, onMounted, watch} from 'vue'
import {useI18n} from "vue-i18n";
import {useRoute, useRouter} from "vue-router";
import {getProductById} from "@/services/api/products.js";
import EntityForm from "@/components/common/Form.vue";
import BasePage from "@/components/Layouts/BasePage.vue";
import {ProductEntity} from "@/entities/ProductEntity.js";
import {formatNumber} from "@/utils/numberFormat.js";
import Text from "@/components/common/Text.vue";
import BaseTable from "@/components/tables/BaseTable.vue";
import {useTablePagination} from "@/js/composables/useTablePagination.js";

const { t, locale } = useI18n();
const loadingMounted = ref(false);
const route = useRoute();
const form = ref(null)
const Product = new ProductEntity();
const entity = ref(Product);
const formData = ref(entity.value.fields);
const totalItems = ref(0);
const items = ref([]);
const router = useRouter();
const actions = ref({ view: "view" });
const haveItems = ref(false);
function onView(item) {
    router.push("/products/view/" + item.id);
}

watch(
    () => route.params.id,
    async () => {
        try {
            let id = route.params.id;
            if (!id) return;

            loadingMounted.value = false;
            let { data } = await getProductById({ id });

            if (data) {
                data = {
                    ...data,
                    max_download: formatNumber(data.max_download, locale, 0),
                    max_upload: formatNumber(data.max_upload, locale, 0),
                    price: formatNumber(data.price, locale.value) || null,
                    st_product_service: data.st_product_service === "S" ? t("components.contracts.product.service") :
                        data.st_product_service === "P" ? t("components.contracts.product.product") :  "",
                };
            }

            if(data.st_combo) {
                haveItems.value = true;
                items.value = Object.entries(data.combo || {}).map(([id, item]) => ({
                    id,
                    ...item
                }));
            } else {
                haveItems.value = false;
            }

            formData.value = data;
        } catch (e) {
            console.error(e);
        } finally {
            loadingMounted.value = true;
        }
    },
    { immediate: true }
);

const {
    paginatedItems: paginated,
    totalInfo: total,
    currentPage: currentPage,
    itemsPerPage: itemsPerPage,
    onPageChange: onPageChange
} = useTablePagination({
    items: items,
    page: 1,
    perPage: 10
});
</script>

<template >
    <BasePage :loading-mounted="loadingMounted" :entity="entity">
        <template v-if="loadingMounted" #default>
            <EntityForm :entity="entity" v-model="formData" disabled="true" ref="form" />
            <template v-if="haveItems" >
                <Text tag="h5" class="mb-8 mt-5">{{ t('components.contracts.product.pageTitle')}}</Text>
                <BaseTable
                    :fetchData="null"
                    :entity="entity"
                    :items="paginated"
                    :loading="!loadingMounted"
                    :totalItems="total"
                    tableToUse="productColumns"
                    :currentPage="currentPage"
                    :itemsPerPage="itemsPerPage"
                    :actions="actions"
                    @page-change="onPageChange"
                    @view="onView"
                >
                </BaseTable>
            </template>
        </template>
    </BasePage>
</template>
